/* ============
 * Default Layout
 * ============
 *
 * Used for the home and account pages
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

export default {
  components: {
    VNavBar: require('components/navbar/navbar.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/layouts/app/app.js